import { mobile } from "../../../mediaQueries";

const styles = (theme) => ({
  root: {
    cursor: "none !important",

    width: "100%",
    display: "flex",
    position: "fixed",
    zIndex: "1000",
    top: "-1px",
    background:
      "-webkit-gradient(linear,left top,left bottom,from(rgb(152, 153, 148)),to(rgba(255,255,255,0.001)))",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "37px 44px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "18px 10px",
    },
  },
  span: {
    cursor: "none !important",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 10px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "0",
    },
  },
  button: {
    cursor: "none !important",

    margin: "0 15px",
    textDecoration: "none",
    backgroundColor: (props) => `${props.btnBackground}`,
    color: (props) => props.btnColor,
    borderRadius: 0,
    fontFamily: "Aktiv Grotesk",
    letterSpacing: "0.01em",
    fontSize: "14px",
    transition: "all 0.4s",
    padding: "12px 22px",
    "&:hover": {
      backgroundColor: "#09349C",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      margin: "0",
    },
  },
  logo: {
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      width: "100px",
    },
  },
  menu: {
    cursor: "none !important",

    margin: "0 15px",

    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      margin: 0,
      marginLeft: "15px",
    },
  },
  a: {
    cursor: "none !important",

    margin: 0,
    padding: 0,
  },
});

export default styles;
